import { render, staticRenderFns } from "./ROTableExpeditionsService.vue?vue&type=template&id=6707ef12&scoped=true&"
import script from "./ROTableExpeditionsService.vue?vue&type=script&lang=js&"
export * from "./ROTableExpeditionsService.vue?vue&type=script&lang=js&"
import style0 from "./ROTableExpeditionsService.vue?vue&type=style&index=0&id=6707ef12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707ef12",
  null
  
)

export default component.exports